import React from 'react';

const ModalLoader = () => {
  return (
    <React.Fragment>
      <div className="modal-loader-container">
        <div className="modal-loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ModalLoader;
